import React from 'react'

import { twMerge } from 'tailwind-merge'

import Chip, { type ChipProps } from '@/components/common/Chip'

interface FilterChip extends ChipProps {}

const FilterChip: React.FC<FilterChip> = ({ variant, className, ...props }) => {
  return (
    <Chip
      variant={variant ?? 'positive'}
      className={twMerge('!text-xs py-0.5 !items-start', className)}
      {...props}
    />
  )
}

export default FilterChip
